import { render, staticRenderFns } from "./payment-code.vue?vue&type=template&id=974da132&scoped=true&"
import script from "./payment-code.vue?vue&type=script&lang=js&"
export * from "./payment-code.vue?vue&type=script&lang=js&"
import style0 from "./payment-code.vue?vue&type=style&index=0&id=974da132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974da132",
  null
  
)

component.options.__file = "payment-code.vue"
export default component.exports